var exports = {
  "N": "x234b8571--247819--card",
};

module.exports = exports;
